export default __webpack_public_path__ + "static/media/industry4.43fd91ed.png";